import { useEffect, useState } from 'react';
import { BridgeApi } from '@lmt/main-renderer-shared';

export function getBridge() {
  return (window as any).api as BridgeApi;
}
export function useGetDataFromMain<T>(
  func: (bridge: BridgeApi) => Promise<T>,
): T | undefined {
  const [data, setData] = useState<T | undefined>(undefined);
  useEffect(() => {
    func(getBridge())
      .then((result) => {
        setData(result);
      })
      .catch((e) => console.error('useGetDataFromMain', e));
  }, []);
  return data;
}

export function configureLogging(bridge: BridgeApi) {
  if (process.env.NODE_ENV !== 'development') {
    Object.assign(console, {
      log: (...params: any[]) => bridge.consoleLog(JSON.stringify(params)),
      warn: (...params: any[]) => bridge.consoleWarn(JSON.stringify(params)),
      error: (...params: any[]) => {
        bridge.consoleError(
          JSON.stringify(
            params.map((param) => {
              if (!param) return param;
              if (param.stack) {
                return {
                  stack: postProcessStackTrace(param.stack),
                  message: param.toString(),
                  cause: param.cause,
                };
              }
              return param;
            }),
          ),
        );
      },
    });
  }
}

function postProcessStackTrace(stack: string) {
  if (typeof stack !== 'string') return stack;

  return stack.replaceAll(
    /file:.*?resources\/app.asar\/build\/stati\/js\//g,
    '',
  );
  // stacktrace in Electron looks like this:
  // Error: test error\n
  //    at rc (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:8151649)
  //    at xa (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:7353827)
  //    at Ts (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:7365515)
  //
  // We convert it to the following, to be able to decode it using the `stacktracify` package.
  // Error: test error\n
  //    at rc (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:8151649)
  //    at xa (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:7353827)
  //    at Ts (file:///C:/Program%20Files/LM%20Patient%20Manager/resources/app.asar/build/static/js/main.140261d0.js:75:7365515)
  //
  // How to use:
  // 1. Download the sourcemap file for `main.js` from the pipeline for the EXACT same version as the user's app.
  // 2. Put the sourcemap file (e.g. `main.140261d0.js`) in the current folder.
  // 3. Copy the stacktrace (taken from the user's logs) into buffer
  // 4. Run the tool: `npx stacktracify .\main.140261d0.js.map`
  // You should see the output like below:
  // Error: test error
  //    at [unknown] (../../../@lmt/unicorn-shared/src/app/components/toolbar/UniToolBar.tsx:180:10)
  //    at c (../../../node_modules/react-dom/cjs/react-dom.production.min.js:167:136)
  //    at Xh (../../../node_modules/react-dom/cjs/react-dom.production.min.js:197:257)
  //    at dj (../../../node_modules/react-dom/cjs/react-dom.production.min.js:292:87)
}
